import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode; fallbackTitle?: string }
type State = { error: Error | null }

/**
 * Evita tela branca no Safari quando um filho do Hub lança exceção.
 */
export class HubErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[HubErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      const title = this.props.fallbackTitle || 'Algo falhou nesta tela'
      return (
        <div className="bp-page">
          <div className="bp-card">
            <p className="bp-error">{title}</p>
            <p className="bp-muted" style={{ marginTop: 0 }}>
              Recarregue a página. Se continuar, use o site clássico ou limpe os dados deste site no
              Safari.
            </p>
            <div className="bp-stack" style={{ marginTop: '0.75rem' }}>
              <button type="button" className="bp-btn bp-btn--primary" onClick={() => window.location.reload()}>
                Recarregar
              </button>
              <a className="bp-btn" href="/hub/inicio">
                Voltar ao início
              </a>
              <a className="bp-btn" href="/login?classic=1">
                Site clássico
              </a>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
